import { FETCH_FAQ } from './constants'

export const fetchFaqs = {
  request: (phoneIds) => ({ type: FETCH_FAQ.REQUEST, phoneIds }),
  success: (devices) => ({ type: FETCH_FAQ.SUCCESS, devices })
}
